<div mat-dialog-title>
	<span translate>
		cancel.issue
	</span>

	<button type="button" mat-icon-button class="close-button"
	(click)="evtCancel()">
		<mat-icon color="accent" svgIcon="md:close"></mat-icon>
	</button>
</div>

<div mat-dialog-content>
	<p>
		<span translate>want.to.cancel.issue</span>
		<b *ngIf="issueName" class="delete-popup-alignment">{{issueName}}</b>
		<span class="delete-popup-alignment">?</span>
	</p>

	<p>
		<span translate>confirmation.message</span>
	</p>
</div>

<div mat-dialog-actions>
	<button type="button" mat-raised-button
		class="dialog-button" (click)="evtConfirm()" tabindex="-1" copoFocusMe>
		<span translate>dialog.apply</span>
	</button>
</div>
